import { lazyImport } from '@ambiki/impulse';

import './elements/user_onboarding_element';
import './elements/signature_pad_element';
import './elements/signature_upload_element';
// import './elements/explorer_checklist_element';
import './elements/onboarding_bubble_element';
import './elements/onboarding_npi_validator_element';

lazyImport('user-signature', () => import('./elements/user_signature_element'));
lazyImport('user-edit-profile', () => import('./elements/user_edit_profile_element'));
